import { mapJsonParamToBookingProduct } from './mapJsonParamToBookingProduct.js'
import { mapStringParamToBookingProduct } from './mapStringParamToBookingProduct.js'
import { mapNonScheduledBookingProducts } from './mapNonScheduledBookingProducts.js'
import { Success, Failure } from 'folktale/validation'
import isJson from '@v/util/isJson.js'

/**
 * Reduces an array of validations concatenating errors as well as wrapped values
 * @param {accumulator} a
 * @param {next validation} n
 */
const validationReducer = (a, n) =>
  a.fold(
    () => a.concat(n),
    values =>
      n.fold(
        errors => Failure(errors),
        other => Success(values.concat(other)),
      ),
  )

export function mapSearchParamsToBookingProducts({ searchParams, products, booking }) {
  const urlParams = new URLSearchParams(searchParams)
  const { slots, extrasslots } = getSlots(urlParams)
  const scheduledProducts = products.filter(p => p.NeedsToBeScheduled)
  const nonScheduledProducts = products.filter(p => !p.NeedsToBeScheduled)
  const validation = [
    [mapScheduledBookingProducts(scheduledProducts), slots],
    [mapNonScheduledBookingProducts(nonScheduledProducts), extrasslots],
  ]
    .map(([f, s]) => buildSlotsPipe(booking, f)(s))
    .reduce(validationReducer, Success([]))
    .map(transferProductGroupName)

  return validation
}

const buildSlotsPipe = (booking, f) => slots => {
  const mapQuantities = validation => validation.map(x => [transferQuantity(booking)(x)])
  return slots
    .map(f)
    .map(mapQuantities)
    .reduce(validationReducer, Success([]))
}

function getSlots(urlParams) {
  return Array.from(urlParams.entries()).reduce(
    (obj, next) => {
      if (next[0].startsWith('extrasslots') && next[1]) obj.extrasslots.push(next[1])
      if (next[0].startsWith('slot') && next[1]) obj.slots.push(next[1])
      return obj
    },
    { slots: [], extrasslots: [] },
  )
}

const transferQuantity = booking => bookingProductParamater => {
  if (booking.NumberOfPersons) bookingProductParamater.ProductQuantity = booking.NumberOfPersons
  return bookingProductParamater
  // todo: only transfer quantities per segment if segments match
  // if (booking.numberOfPersonsPerClassification)
  //   bookingProductParamater.quantitiesPerClassification = booking.numberOfPersonsPerClassification.map(
  //     c => ({
  //       classificationCode: c.classificationCode,
  //       quantitiesPerSegment: c.numberOfPersonsPerSegment.map(s => ({
  //         segmentCode: s.segmentCode,
  //         quantity: s.numberOfPersons,
  //       })),
  //     }),
  //   )
}

// queryParam contains the new booking product as a string
// For a single product, it contains the resource key and datetime separated by '|'
// For a product that's part of a deal, it is a JSON containing more info like deal key
const mapScheduledBookingProducts = products => queryParam => {
  return isJson(queryParam)
    ? mapJsonParamToBookingProduct(products, queryParam)
    : mapStringParamToBookingProduct(products, queryParam)
}

// PF 2020-08-21: this function was created for hotfix; should be refactored
function transferProductGroupName(newBookingProducts) {
  return newBookingProducts.map(bp => {
    if (!bp.NeedsToBeScheduled && bp.ProductGroupKey && !bp.ProductGroupName) {
      const other = newBookingProducts.find(
        other => other.ProductGroupKey === bp.ProductGroupKey && other.NeedsToBeScheduled,
      )
      bp.ProductGroupName = other.ProductGroupName
    }
    return bp
  })
}
